import { Link } from "react-router-dom";
import "../../style/scss/App.scss";
import { FaThumbsDown as ThumbsDown, FaThumbsUp as ThumbsUp, FaRegMeh as Meh } from "react-icons/fa";

export default function PersonSkillListItem({ skill, personSkill }) {
   var experienceDisplay = personSkill.ExperienceMonths<16 ? personSkill.ExperienceMonths + " mo" : Math.floor(personSkill.ExperienceMonths/12) + " yr";
   var title = "";
   if (skill.ParentSkillName) title = skill.ParentSkillName + ": " + skill.Name;
   else title = skill.Name;
   const levelNames = { 1: "Beginner", 2: "Junior", 3: "Intermediate", 4: "Senior", 5: "Guru" };
   const verifiedLabel =
      personSkill.Certified || personSkill.VerifiedSkillLevel
         ? `Verified: ${levelNames[personSkill.VerifiedSkillLevel] || personSkill.VerifiedSkillLevel}`
         : null;
   return (
      <Link to={"/personSkill/" + personSkill.ID} className="centered skillLink">
         <div className="Skill mobilePanel">
            <span className="title">
               {title}
               {verifiedLabel ? (
                  <span className="verifiedBadge" title="Type 1 certification">
                     {" "}
                     [{verifiedLabel}]
                  </span>
               ) : null}
            </span>
            <span className="byline">{skill.CategoryName}</span>
            <span className="rightText">
               {experienceDisplay} at {(personSkill.Employments || []).length} jobs
               <span className="icon">
                  <span className={personSkill.InterestLevelID === 1 ? "" : "hidden"}>
                     <ThumbsUp className="interestLevelIcon up" />
                  </span>
                  <span className={personSkill.InterestLevelID === 0 ? "" : "hidden"}>
                     <Meh className="interestLevelIcon meh" />
                  </span>
                  <span className={personSkill.InterestLevelID === 2 ? "" : "hidden"}>
                     <ThumbsDown className="interestLevelIcon down" />
                  </span>
               </span>
            </span>
         </div>
      </Link>
   );
}

